module.exports = __webpack_public_path__ + "static/img/D1.c1f209d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mjhl2/D1.png
// module id = VvBB
// module chunks = 0